var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "ptc_container"
  }, [_c('div', {
    staticClass: "info_section"
  }, [_c('div', {
    staticClass: "info_txt"
  }, [_c('span', {
    staticClass: "lbtx"
  }, [_vm._v("프로토콜이란?")]), _vm._m(1), _c('hr', {
    staticClass: "hr_line"
  }), _c('p', {
    staticClass: "txt_typ_3"
  }, [_vm._v("전문가의 노하우가 측정·분석 프로토콜의 요소 항목과 메타정보를 포함한 데이터입니다.")]), _vm._m(2), _c('a', {
    staticClass: "info_txt_btn",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("프로토콜 만들어 보기")])]), _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require(`@/style/new/images/info/protocol_01.png`),
      "alt": ""
    }
  })])])]), _c('div', {
    staticClass: "info_section"
  }, [_vm._m(3), _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require(`@/style/new/images/info/protocol_02.png`),
      "alt": ""
    }
  })])])]), _c('div', {
    staticClass: "info_section"
  }, [_vm._m(4), _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require(`@/style/new/images/info/protocol_03.png`),
      "alt": ""
    }
  })]), _c('p', {
    staticClass: "desc_txt typ1"
  }, [_vm._v("프로토콜 플랫폼은 복잡한 소재 제작과정을 쉽고 편리하게 제작할 수 있는 프로토콜 에디터 기능을 제공하여, 나만의 연구 과정을 쉽게 정리 할 수 있습니다.")]), _vm._m(5)])])]), _c('div', {
    staticClass: "btm_banner"
  }, [_c('div', {
    staticClass: "btm_banner_inner"
  }, [_c('p', [_vm._v("효율적인 연구를 하기위한 프로토콜을 만들어보세요.")]), _c('a', {
    staticClass: "linkbtn",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("프로토콜 만들어 보기")])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub_top"
  }, [_c('div', {
    staticClass: "sub_tit"
  }, [_c('div', {
    staticClass: "sub_tit_inner"
  }, [_c('h2', [_vm._v("프로토콜")])])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "txt_typ_lg"
  }, [_c('span', {
    staticClass: "txt_ib"
  }, [_vm._v("측정/분석을 위한 ")]), _vm._v(" "), _c('span', {
    staticClass: "txt_ib"
  }, [_vm._v("표준화된 절차/지침서")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "txt_typ_3"
  }, [_vm._v("프로토콜 플랫폼에서는 "), _c('strong', [_vm._v("트리와 위키 2가지의 형식")]), _vm._v("으로 프로토콜을 정리하고 사용할 수 있습니다.")]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info_txt"
  }, [_c('span', {
    staticClass: "lbtx"
  }, [_vm._v("CheckPoint 01")]), _c('p', {
    staticClass: "txt_typ_md"
  }, [_c('span', {
    staticClass: "colr"
  }, [_vm._v("[트리보기]")]), _vm._v(" 에서는 분석을 위한 전체적인 정보를 확인할 수 있습니다.")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info_txt"
  }, [_c('span', {
    staticClass: "lbtx"
  }, [_vm._v("CheckPoint 02")]), _c('p', {
    staticClass: "txt_typ_md"
  }, [_c('span', {
    staticClass: "colr"
  }, [_vm._v("[위키보기]")]), _vm._v(" 에서는 각 항목의 상세한 정보를 확인할 수 있습니다.")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "desc_txt typ2"
  }, [_vm._v("또한 전문가들이 "), _c('span', {
    staticClass: "colr"
  }, [_vm._v("검증하고 공개한 다양한 공정들을 검색하고 활용")]), _vm._v("할 수 있어, 더욱 효율적인 연구를 할 수 있도록 도와줍니다.")]);

}]

export { render, staticRenderFns }